/** Nominal QA phantom targets (mm / spatial res). Used for MRI QA limits and charts. */
export const QaPhantomLimits = {
  Large: {
    geoHf: 148,
    geoApRl: 190,
    spatialRes: 1.0,
  },
  Medium: {
    geoHf: 134,
    geoApRl: 165,
    spatialRes: 1.0,
  },
  Small: {
    geoHf: 100,
    geoApRl: 100,
    spatialRes: 0.8,
  },
};

const fallbackPhantom = 'Large';

export const resolvePhantomSize = (phantomSize) =>
  phantomSize && QaPhantomLimits[phantomSize] ? phantomSize : fallbackPhantom;

/** Acceptable geometric accuracy bands (nominal ± 2 mm), keyed by axis group. */
export const getGeoAccuracyBands = (phantomSize) => {
  const key = resolvePhantomSize(phantomSize);
  const { geoHf, geoApRl } = QaPhantomLimits[key];
  return {
    hf: { min: geoHf - 2, max: geoHf + 2 },
    apRl: { min: geoApRl - 2, max: geoApRl + 2 },
  };
};
